import { FormControl, FormHelperText, InputLabel, MenuItem, Select, } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

function SelectComponent(props) {
  const { theme } = useTheme();
  const isError = props.required && (!props.value || props.value === "");

  const title = props.title.replaceAll(" ", "-").toLowerCase();
  return (
    <FormControl
      size={props.size}
      sx={{
        mr: 1, fontFamily: theme.fontFamily,
        "& .MuiInputLabel-outlined.Mui-error": {
          color: theme.accent.error,
        },
        "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.accent.error,
        },
      }}
      variant="outlined"
      fullWidth
      error={isError}
      id={props.idName ? props.idName : ""}
    >
      <InputLabel
        id={`select-label-${title}`}
        sx={{
          fontFamily: theme.fontFamily,
          color: theme.text.primary,
          '&.Mui-focused': {
            color: theme.color.primary, // Change label color on focus
          },
        }}
      >
        {!isError ? props.title : `${props.title} *`}
      </InputLabel>
      <Select
        labelId={`select-label-${title}`}
        id={`select-${title}`}
        value={props.value} // Pass the value directly
        label={!isError ? props.title : `${props.title} *`}
        onChange={(e) => props.onChange(e.target.value)}
        sx={{
          color: theme.text.primary,
          fontFamily: theme.fontFamily,
          '& .MuiSelect-icon': {
            color: theme.text.primary, // Set chevron icon color
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.text.primary, // Set border color
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.text.primary, // Set border color on hover
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.color.primary, // Set border color when focused
          },
        }}
      >
        {props.options.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ fontFamily: theme.fontFamily }}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectComponent;
